import { Link } from "react-router-dom";
import { ArrowLeft, LogIn, ShieldCheck } from "lucide-react";
import { ASSETS } from "@/lib/assets";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const signIn = () => {
    const redirectUrl = window.location.origin + "/admin/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 spotlight" />
      <div className="relative z-10 w-full max-w-md">
        <Link to="/" data-testid="admin-login-back" className="inline-flex items-center gap-2 text-zinc-500 hover:text-wutn font-cond uppercase tracking-wider text-xs mb-10 transition-colors">
          <ArrowLeft className="h-3.5 w-3.5" /> Back To Site
        </Link>

        <div className="flex items-center gap-4 mb-10">
          <img src={ASSETS.logoIcon} alt="WUTN" className="h-14 w-14 object-contain" />
          <div>
            <div className="font-cond uppercase tracking-widest text-xs text-wutn">Admin</div>
            <div className="font-display uppercase text-2xl leading-none">Wake-Up The Nation</div>
          </div>
        </div>

        <h1 className="font-display uppercase text-5xl leading-[0.9]">Sign <span className="text-wutn">In</span></h1>
        <p className="mt-4 text-zinc-400">Access the ministry dashboard to manage events, sermons, blog, and the gallery.</p>

        <button
          onClick={signIn}
          data-testid="admin-google-signin"
          className="mt-10 w-full inline-flex items-center justify-center gap-3 bg-wutn hover:bg-wutn-dark text-white px-6 py-4 font-cond uppercase tracking-wider text-sm transition-colors"
        >
          <LogIn className="h-5 w-5" /> Sign In With Google
        </button>

        <div className="mt-6 flex items-start gap-3 text-xs text-zinc-500">
          <ShieldCheck className="h-4 w-4 text-wutn shrink-0 mt-0.5" />
          <span>Access is restricted to approved ministry administrators.</span>
        </div>
      </div>
    </div>
  );
}
